<!-- Modal Header -->
<div class="modal-header">
    <h3 class="modal-title">
      {{ modalTitle }}
      <i (click)="cancel()" class="fa fa-times pull-right cursor-pointer"></i>
      <i 
        class="fa pull-right cursor-pointer" 
        [ngClass]="{'fa-plus-square-o': minimized, 'fa-minus-square-o': !minimized}" 
        style="margin-right: 10px" 
        (click)="toggleMinimized()">
      </i>
    </h3>
  </div>
  
  <!-- Loading Spinner -->
  <div class="modal-body" [hidden]="minimized || !showEntityLoader">
    <div class="row formLoader">
      <div class="col-md-5"></div>
      <div class="col-md-2">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
      <div class="col-md-5"></div>
    </div>
  </div>
  
  <!-- Main Form Content -->
  <div class="modal-body" [hidden]="minimized || showEntityLoader">
    <form [formGroup]="entityForm" novalidate>
      
      <!-- Entity Details Panel -->
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4><b>Entity Details:</b></h4>
        </div>
        <div class="panel-body">
          
          <div class="row">
            <!-- Legal Entity ID -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="legalEntityId"><b>Legal Entity Id<sup>*</sup>:</b></label>
                <input 
                  list="legalEntityIdList" 
                  class="form-control" 
                  id="legalEntityId" 
                  formControlName="CHILD_ID"
                  placeholder="Select Entity" 
                  [class.is-invalid]="hasFieldError('CHILD_ID')"
                  (blur)="onLeidChange()"
                  required>
                <datalist id="legalEntityIdList">
                  @for (entity of allEntities; track trackByEntityId($index, entity)) {
<option 
                    
                    [value]="entity.CHILD_ID">
                    {{ entity.LE_SHORT_NAME }}
                  </option>
}
                </datalist>
                @if (hasFieldError('CHILD_ID')) {
<small class="text-danger">
                  {{ getFieldError('CHILD_ID') }}
                </small>
}
              </div>
            </div>
            
            <!-- Reporting Period -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="reportingPeriod"><b>Reporting Period<sup>*</sup>:</b></label>
                <select 
                  class="form-control" 
                  id="reportingPeriodList" 
                  formControlName="STUB"
                  [class.is-invalid]="hasFieldError('STUB')"
                  (change)="onReportingPeriodChange($event)">
                  <option value="">Select Reporting Period</option>
                  @for (stub of reportingPeriods; track $index) {
<option 
                    
                    [value]="stub.value">
                    {{ stub.label }}
                  </option>
}
                </select>
                @if (hasFieldError('STUB')) {
<small class="text-danger">
                  {{ getFieldError('STUB') }}
                </small>
}
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Tax Year Begin -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="taxYearBegin"><b>Tax Year Begin<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="taxYearBegin" 
                    formControlName="START_DATE"
                    [class.is-invalid]="hasFieldError('START_DATE')"
                    required>
                </div>
                @if (hasFieldError('START_DATE')) {
<small class="text-danger">
                  {{ getFieldError('START_DATE') }}
                </small>
}
              </div>
            </div>
            
            <!-- Tax Year End -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="taxYearEnd"><b>Tax Year End<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="taxYearEnd" 
                    formControlName="END_DATE"
                    [class.is-invalid]="hasFieldError('END_DATE')"
                    required>
                </div>
                @if (hasFieldError('END_DATE')) {
<small class="text-danger">
                  {{ getFieldError('END_DATE') }}
                </small>
}
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- LE Short Name -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="leShortName"><b>LE Short Name:</b></label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="leShortName" 
                  formControlName="LE_SHORT_NAME"
                  placeholder="Enter LE Short Name">
              </div>
            </div>
            
            <!-- GECC Entity ID -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="geccEntityId"><b>GECC Entity ID:</b></label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="geccEntityId" 
                  formControlName="GECC_ENTITY_ID"
                  placeholder="Enter GECC Entity ID">
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Tax Type -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="taxType"><b>Tax Type<sup>*</sup>:</b></label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="taxType" 
                  formControlName="TAX_TYPE"
                  [class.is-invalid]="hasFieldError('TAX_TYPE')"
                  placeholder="Enter Tax Type" 
                  required>
                @if (hasFieldError('TAX_TYPE')) {
<small class="text-danger">
                  {{ getFieldError('TAX_TYPE') }}
                </small>
}
              </div>
            </div>
            
            <!-- Classification -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="classification"><b>Classification<sup>*</sup>:</b></label>
                <select 
                  class="form-control" 
                  id="classification" 
                  formControlName="CLASSIFICATION"
                  [class.is-invalid]="hasFieldError('CLASSIFICATION')"
                  required>
                  <option value="">Select Classification</option>
                  @for (classification of allClassifications; track $index) {
<option 
                    
                    [value]="classification.CLASSIFICATION">
                    {{ classification.CLASSIFICATION_DESC }}
                  </option>
}
                </select>
                @if (hasFieldError('CLASSIFICATION')) {
<small class="text-danger">
                  {{ getFieldError('CLASSIFICATION') }}
                </small>
}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="goldStartDate"><b>GOLD START DATE:</b></label>
                <input type="date" class="form-control" id="goldStartDate" formControlName="GOLD_START_DATE">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="goldEndDate"><b>GOLD END DATE:</b></label>
                <input type="date" class="form-control" id="goldEndDate" formControlName="GOLD_END_DATE">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="techTerm"><b>TECH TERM:</b></label>
                <input type="text" class="form-control" id="techTerm" formControlName="TECH_TERM">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="singleOwnership"><b>SINGLE OWNERPSHIP:</b></label>
                <input type="text" class="form-control" id="singleOwnership" formControlName="SINGLE_OWNER_PSHIP">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="subConsol"><b>SUB CONSOL:</b></label>
                <input type="text" class="form-control" id="subConsol" formControlName="SUB_CONSOL">
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Acquisition Date -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="acquisitionDate"><b>Acquisition Date:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="acquisitionDate" 
                    formControlName="ACQUISITION_DATE">
                </div>
              </div>
            </div>
            
            <!-- Date Incorporated -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="dateIncorporated"><b>Date Incorporated<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="dateIncorporated" 
                    formControlName="DATE_INCORPORATED"
                    [class.is-invalid]="hasFieldError('DATE_INCORPORATED')"
                    required>
                </div>
                @if (hasFieldError('DATE_INCORPORATED')) {
<small class="text-danger">
                  {{ getFieldError('DATE_INCORPORATED') }}
                </small>
}
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Date Spawned/Consumed -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="dateSpawnedConsumed"><b>Date Spawned/Consumed:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="dateSpawnedConsumed" 
                    formControlName="DATE_SPAWNED_CONSUMED">
                </div>
              </div>
            </div>
            
            <!-- Date Dissolved -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="dateDissolved"><b>Date Dissolved:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="dateDissolved" 
                    formControlName="DATE_DISSOLVED">
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Date Liquidated -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="dateLiquidated"><b>Date Liquidated:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="dateLiquidated" 
                    formControlName="DATE_LIQUIDATED">
                </div>
              </div>
            </div>
            
            <!-- Date Sold -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="dateSold"><b>Date Sold:</b></label>
                <div class="input-group">
                  <input 
                    type="date" 
                    class="form-control" 
                    id="dateSold" 
                    formControlName="DATE_SOLD">
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Tax Consolidation Group -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="taxConsolidationGroup"><b>Tax Consolidation Group<sup>*</sup>:</b></label>
                <select 
                  class="form-control" 
                  id="taxConsolidationGroup" 
                  formControlName="TAX_CONSOLIDATION_GRP"
                  [class.is-invalid]="hasFieldError('TAX_CONSOLIDATION_GRP')"
                  required>
                  <option value="">Select Tax Consolidation Group</option>
                  @for (group of allTaxConsolidationGroups; track $index) {
<option 
                    
                    [value]="group.TAX_CONSOLIDATION_GRP">
                    {{ group.TAX_CONSOLIDATION_GRP_DESC }}
                  </option>
}
                </select>
                @if (hasFieldError('TAX_CONSOLIDATION_GRP')) {
<small class="text-danger">
                  {{ getFieldError('TAX_CONSOLIDATION_GRP') }}
                </small>
}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Additional Details Panel -->
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row">
            <!-- Country Incorporated -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="countryIncorporated"><b>Country Incorporated<sup>*</sup>:</b></label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="countryIncorporated" 
                  formControlName="COUNTRY_INCORPORATED"
                  [class.is-invalid]="hasFieldError('COUNTRY_INCORPORATED')"
                  placeholder="Enter Country Incorporated" 
                  required>
                @if (hasFieldError('COUNTRY_INCORPORATED')) {
<small class="text-danger">
                  {{ getFieldError('COUNTRY_INCORPORATED') }}
                </small>
}
              </div>
            </div>
            
            <!-- Return Prepared By -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="returnPreparedBy"><b>Return Prepared By<sup>*</sup>:</b></label>
                <select 
                  class="form-control" 
                  id="returnPreparedBy" 
                  formControlName="RETURN_PREPARED_BY"
                  [class.is-invalid]="hasFieldError('RETURN_PREPARED_BY')"
                  required>
                  <option value="">Select Return Prepared By</option>
                  @for (option of RETURN_PREPARED_BY_OPTIONS; track $index) {
<option 
                    
                    [value]="option.value">
                    {{ option.label }}
                  </option>
}
                </select>
                @if (hasFieldError('RETURN_PREPARED_BY')) {
<small class="text-danger">
                  {{ getFieldError('RETURN_PREPARED_BY') }}
                </small>
}
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Reason for Override -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="reasonForOverride"><b>Reason for Override:</b></label>
                <textarea 
                  class="form-control" 
                  id="reasonForOverride" 
                  formControlName="EDIT_COMMENTS"
                  placeholder="Enter Reason for Override" 
                  rows="3">
                </textarea>
              </div>
            </div>
            
            <!-- Entity Type -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="entityType"><b>Entity Type<sup>*</sup>:</b></label>
                <div>
                  @for (option of ENTITY_TYPE_OPTIONS; track $index) {
<label 
                    
                    class="radio-inline">
                    <input 
                      class="form-check-input" 
                      type="radio" 
                      [value]="option.value" 
                      formControlName="ENTITY_TYPE"
                      [id]="'entityType' + option.value">
                    {{ option.label }}
                  </label>
}
                </div>
                @if (hasFieldError('ENTITY_TYPE')) {
<small class="text-danger">
                  {{ getFieldError('ENTITY_TYPE') }}
                </small>
}
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- Filing Requirement -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="filingRequirement"><b>Filing Requirement<sup>*</sup>:</b></label>
                <div>
                  @for (option of YES_NO_OPTIONS; track $index) {
<label 
                    
                    class="radio-inline">
                    <input 
                      class="form-check-input" 
                      type="radio" 
                      [value]="option.value" 
                      formControlName="FILING_REQUIREMENT"
                      [id]="'filingRequirement' + option.value">
                    {{ option.label }}
                  </label>
}
                </div>
                @if (hasFieldError('FILING_REQUIREMENT')) {
<small class="text-danger">
                  {{ getFieldError('FILING_REQUIREMENT') }}
                </small>
}
              </div>
            </div>
            
            <!-- Roll Forward -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="rollForward"><b>Roll Forward to next year<sup>*</sup>:</b></label>
                <div>
                  @for (option of YES_NO_OPTIONS; track $index) {
<label 
                    
                    class="radio-inline">
                    <input 
                      class="form-check-input" 
                      type="radio" 
                      [value]="option.value" 
                      formControlName="ROLL_FORWARD"
                      [id]="'rollForward' + option.value">
                    {{ option.label }}
                  </label>
}
                </div>
                @if (hasFieldError('ROLL_FORWARD')) {
<small class="text-danger">
                  {{ getFieldError('ROLL_FORWARD') }}
                </small>
}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- HO Details Panel -->
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4><b>HO Details:</b></h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="homeOfficeLeid"><b>Home Office LEID:</b></label>
                <input type="text" class="form-control" id="homeOfficeLeid" formControlName="HO_LEIDS">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="hoTaxCode"><b>HO Tax Code:</b></label>
                <input type="text" class="form-control" id="hoTaxCode" formControlName="HO_GECC_ENTITY_ID">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="hoTaxType"><b>HO Tax Type:</b></label>
                <input type="text" class="form-control" id="hoTaxType" formControlName="HO_TAX_TYPE">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="hoCountryIncorporated"><b>HO Country Incorporated:</b></label>
                <input type="text" class="form-control" id="hoCountryIncorporated" formControlName="HO_COUNTRY_INCORPORATED">
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- US HO Details Panel -->
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4><b>US HO Details:</b></h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <!-- US HO LEID -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="usHoLeid"><b>US HO LEID:</b></label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="usHoLeid" 
                  formControlName="US_HO_LEID"
                  placeholder="Enter US HO LEID">
              </div>
            </div>
            
            <!-- US HO Reporting Period -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="usHoReportingPeriod"><b>US HO REPORTING PERIOD:</b></label>
                <select 
                  class="form-control" 
                  id="usHoReportingPeriod" 
                  formControlName="US_HO_REPORTING_PERIOD">
                  <option value="">Select Period</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </form>
  </div>
  
  <!-- Modal Footer -->
  <div class="modal-footer">
    <button 
      class="btn btn-info btn-sm" 
      type="button" 
      (click)="save()"
      [disabled]="isSaving">
      Create
      @if (isSaving) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
    </button>
    
    <button 
      class="btn btn-danger-outline btn-sm" 
      type="button" 
      (click)="reset()">
      Reset
    </button>
    
    <button 
      class="btn btn-warning btn-sm" 
      type="button" 
      (click)="cancel()">
      Cancel
    </button>
  </div>